module.exports = __webpack_public_path__ + "static/media/anaAwardFuture-head.61db65c1.webp";